import React from 'react';
import { DialogContent as MUIDialogContent } from '@mui/material';
import { useStyles } from './DialogContent.styles';
export function DialogContent(props) {
    const classes = useStyles(props);
    return (React.createElement(MUIDialogContent, { className: props.className, classes: classes, dividers: props.topDivider || props.bottomDivider, id: props.id, "data-testid": props.testid }, props.children));
}
//# sourceMappingURL=DialogContent.js.map